import { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import { dissmissBanner } from '../../apis/queries';
import { User } from '../../types';

interface RootState {
  user: {
    currentUser: User | null;
  };
}

const Banner = () => {
  const currentUser = useSelector((state: RootState) => state.user.currentUser);

  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    setShowBanner(!!currentUser?.showBanner);
  }, [currentUser]);

  const handleDismiss = async () => {
    await dissmissBanner();
    setShowBanner(false);
  };

  if (!showBanner) return <></>;

  return (
    <Alert variant="danger" onClose={handleDismiss} dismissible>
      <Alert.Heading>REMINDER: Set Financial Month Period</Alert.Heading>
      <p>Your current financial month is almost over. Please take a moment to set a date range for the next one</p>
    </Alert>
  );
};

export default Banner;
